import { render, staticRenderFns } from "./CCMConsentFormAdd.vue?vue&type=template&id=f9e84c7c"
import script from "./CCMConsentFormAdd.vue?vue&type=script&lang=js"
export * from "./CCMConsentFormAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports